import Inputmask from "inputmask";

export class EditPaymentCard {
    constructor(optionalOptions = {}) {
        this._form = document.querySelector('.payment--edit-card');
        if (!this._form) {
            this.destructor();
            return true;
        }

        let elementCardCVV = this._form.querySelector('[name="card-cvv"]')
        if (elementCardCVV) {
            Inputmask({
                "clearMaskOnLostFocus": true,
                "clearIncomplete": true,
                "mask": "999"
            }).mask(elementCardCVV);
        }

        let elementCardDate = this._form.querySelector('[name="card-date"]')
        if (elementCardDate) {
            Inputmask({
                "clearMaskOnLostFocus": true,
                "clearIncomplete": true,
                "mask": "99/99"
            }).mask(elementCardDate);
        }

        let elementCardNum = this._form.querySelector('[name="card-num"]')
        if (elementCardNum) {
            Inputmask({
                "clearMaskOnLostFocus": true,
                "clearIncomplete": true,
                "mask": "9999  9999  9999  9999"
            }).mask(elementCardNum);
        }
    }

    destructor() {
        this._form = null;
    }
}

export default new EditPaymentCard();
